/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApolloLink, Operation } from '@apollo/client'

import { Monitor } from '~types/index'

const roundTripLink = (breadcrumbMonitor: Monitor) =>
  new ApolloLink((operation: Operation, forward) => {
    const start: Date = new Date()
    const time = 0
    operation.setContext({ start })
    const { operationName, variables } = operation
    breadcrumbMonitor('deadpool-request', {
      operationName,
      variables,
      time,
      start: start.getTime(),
    })

    return forward(operation).map((data) => {
      const now: Date = new Date()
      const end = now.getTime()
      const time = end - operation.getContext().start

      breadcrumbMonitor('deadpool-response', {
        ...data.data,
        time,
        end,
      })

      return data
    })
  })

export default roundTripLink
